export default __webpack_public_path__ + "px.png";